import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { createStyles, WithStyles } from '@mui/styles';
import { withStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Nav from 'header/Nav';
// import Footer from 'footer/Bar';

const styles = (theme: Theme) => createStyles({
  errorContainer: {
    height: '50vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
});

type Props = RouteComponentProps & WithStyles<typeof styles>;

class Error extends Component<Props> {
  render() {
    const { classes, match } = this.props;
    const errorMessage = match.params ? match.params.message : '';

    return (
      <React.Fragment>
        <Nav />
        <div className={classes.errorContainer}>
          <h1>{errorMessage}</h1>
        </div>
        <footer>
          {/* <Footer /> */}
        </footer>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(withRouter(Error));
